// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SiHaDocumentationStatusModel from '../../model/si-ha-documentation-status-model';
import SiHaDocumentationStatusDTO from '../dto/si-ha-documentation-status-dto';
import dtoSchema from '../schemas/si-ha-documentation-status-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SiHaDocumentationStatusModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SiHaDocumentationStatusDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.name = data.name ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  name?: string;

  static toModel(dto: DeepPartial<SiHaDocumentationStatusDTO>): SiHaDocumentationStatusModel;
  static toModel(dto: DeepPartial<SiHaDocumentationStatusDTO> | undefined | null): SiHaDocumentationStatusModel | undefined;
  static toModel(dto: DeepPartial<SiHaDocumentationStatusDTO> | undefined | null): SiHaDocumentationStatusModel | undefined {
    return dto ? new SiHaDocumentationStatusModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SiHaDocumentationStatusModel> | SiHaDocumentationStatusModel): SiHaDocumentationStatusDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      name: unwrapped.name,
    } as SiHaDocumentationStatusDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SiHaDocumentationStatusModel, can not map to SiHaDocumentationStatusDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
